var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.67,
    height: 27.643,
    viewBox: "0 0 30.67 27.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149703",
    "data-name": "Group 149703",
    transform: "translate(0 -21.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102389",
    "data-name": "Path 102389",
    d: "M26.564,40.494H24.657V25.242a4.1,4.1,0,0,0-4.106-4.106H3.906a.465.465,0,0,0-.22.037,4.13,4.13,0,0,0,0,8.212c.073,0,.147.037.22.037h.22V44.71a4.14,4.14,0,0,0,4.106,4.07H26.564a4.143,4.143,0,0,0,0-8.286ZM4.126,27.185v-.037a1.906,1.906,0,0,1,0-3.813h12.8a4.2,4.2,0,0,0,0,3.85Zm17.6,14.995H6.692v-2.2H21.724Zm0-4.4H6.692v-2.2H21.724Zm0-4.4H6.692v-2.2H21.724ZM26.6,46.506A1.893,1.893,0,0,1,24.694,44.6V42.694H26.6a1.906,1.906,0,0,1,0,3.813Z",
    transform: "translate(0)",
    fill: "#284261"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.d9f01d545bf19419066e0123d7caf4cd.svg";
export { ForwardRef as ReactComponent };